import { el } from "./dom.js";

// A small modal that asks for a new group's name (used when one item is dropped
// onto another). Resolves to the trimmed name, or null if cancelled.
export function showCreateGroupModal({ suggestedName = "" } = {}) {
	return new Promise((resolve) => {
		let settled = false;
		const finish = (value) => {
			if (settled) return;
			settled = true;
			overlay.remove();
			document.removeEventListener("keydown", onKey);
			resolve(value);
		};

		const input = el("input.field__select", {
			type: "text",
			value: suggestedName,
			placeholder: "e.g. Warhammer 40,000",
		});

		const onKey = (e) => {
			if (e.key === "Escape") finish(null);
			if (e.key === "Enter") finish(input.value.trim() || null);
		};
		document.addEventListener("keydown", onKey);

		const overlay = el(
			"div.modal-overlay",
			{
				onclick: (e) => {
					if (e.target === overlay) finish(null);
				},
			},
			el(
				"div.modal",
				{},
				el("h2.modal__title", {}, "Create group"),
				el(
					"p.modal__hint",
					{},
					"Name a group for these two — you can add more and nest subgroups after.",
				),
				el("div.field", {}, el("label.field__label", {}, "Name"), input),
				el(
					"div.modal__actions",
					{},
					el(
						"button.btn",
						{ type: "button", onclick: () => finish(null) },
						"Cancel",
					),
					el(
						"button.btn.btn--primary",
						{
							type: "button",
							onclick: () => finish(input.value.trim() || null),
						},
						"Create",
					),
				),
			),
		);

		document.body.appendChild(overlay);
		queueMicrotask(() => {
			input.focus();
			input.select();
		});
	});
}
